import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { SlideView } from "@/components/SlideView";
import { useResponsive } from "@/context/ResponsiveContext";

// banner = keep exact 1600×460 proportions from tablet up (phones keep a taller box for text)
const HEIGHT = { fixed: "h-[400px] sm:h-[420px] lg:h-[460px]", banner: "h-[400px] sm:h-auto sm:aspect-[1600/460] sm:max-h-[460px]" };

export default function HeroSlider() {
  const [d, setD] = useState(null);
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const rd = useResponsive();
  const H = HEIGHT[rd.hero_mode] || HEIGHT.fixed;
  useEffect(() => { api.get("/site/slides").then((r) => setD(r.data)).catch(() => setD({ slides: [] })); }, []);
  const n = d?.slides.length || 0;
  useEffect(() => {
    if (n < 2 || paused || !d.autoplay_seconds) return;
    const t = setInterval(() => setI((x) => (x + 1) % n), d.autoplay_seconds * 1000);
    return () => clearInterval(t);
  }, [n, paused, d]);
  if (!d) return <section className={`bg-steel ${H}`} />;
  if (!n) return null;
  const go = (k) => setI((k + n) % n);
  return (
    <section className={`relative bg-steel text-white overflow-hidden w-full ${H}`} data-testid="hero-slider" aria-roledescription="carousel" aria-label="Promotions"
      onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      {d.slides.map((s, k) => (
        <div key={s.id} aria-hidden={k !== i} data-testid={`hero-slide-${k}`}
          className={`absolute inset-0 transition-opacity duration-700 ${k === i ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"}`}>
          <div className="relative max-w-[1600px] mx-auto h-full"><SlideView s={s} first={k === 0} idx={k} /></div>
        </div>))}
      {n > 1 && (<>
        <button onClick={() => go(i - 1)} aria-label="Previous slide" data-testid="hero-prev" className="absolute left-3 top-1/2 -translate-y-1/2 z-20 hidden sm:grid place-items-center w-10 h-10 rounded-full bg-black/25 hover:bg-accent hover:text-steel transition-colors"><ChevronLeft size={22} /></button>
        <button onClick={() => go(i + 1)} aria-label="Next slide" data-testid="hero-next" className="absolute right-3 top-1/2 -translate-y-1/2 z-20 hidden sm:grid place-items-center w-10 h-10 rounded-full bg-black/25 hover:bg-accent hover:text-steel transition-colors"><ChevronRight size={22} /></button>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {d.slides.map((s, k) => <button key={s.id} onClick={() => go(k)} aria-label={`Slide ${k + 1}`} data-testid={`hero-dot-${k}`}
            className={`h-2 rounded-full transition-[width,background-color] ${k === i ? "w-6 bg-accent" : "w-2 bg-white/50 hover:bg-white/80"}`} />)}
        </div></>)}
    </section>
  );
}
